export function SignIn({ onSignIn }: { onSignIn: () => Promise<void> }) {
  return (
    <div className="signin-screen">
      <h1>SYNTH-WEB</h1>
      <p className="muted">
        Sign in with the allowlisted Google account to continue.
      </p>
      <button className="btn-primary" onClick={onSignIn}>
        Sign in with Google
      </button>
    </div>
  );
}
